<template>
    <div style="text-align: left">
        <div class="list">用户管理</div>
        <div class="content">
            <div class="goods">
                <div class="search">
                    账号：<el-input style="width:200px" v-model.trim="userList.userName" placeholder="请输入账号"></el-input>
                    <el-button type="primary" style="margin-left:10px" @click="fuzzyQuery">搜 索</el-button>
                    <el-button @click="resetGetList">重 置</el-button>
                </div>
                <br>
                <hr>
                <div style="margin-top: 20px">
                    <el-button type="primary" plain @click="openAdd">新增用户</el-button>
                    <!-- <el-button type="primary" plain>批量删除</el-button> -->
                </div>
            </div>
            <div class="global-table-box">
                <el-table :data="tableData" border style="width: 100%" tooltip-effect="dark" :cell-style="{}">
                    <el-table-column type="index" width="50" label="#" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="nickname" label="名称" width="100" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="accountNumber" label="账号" width="200" header-align="center" max-width="500px"
                        align="center">
                    </el-table-column>
                    <el-table-column prop="roleId" label="角色" width="100" header-align="center" max-width="500px"
                        align="center">
                        <template slot-scope="scope">
                            <el-tag>{{ options | roleFilter(scope.row) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="jobNumber" label="工号" width="120" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="是否在岗" width="120" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tag type="danger" v-if="scope.row.isOnline === '0'">否</el-tag>
                            <el-tag type="success" v-if="scope.row.isOnline === '1'">是</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="phoneNumber" label="手机号" width="120" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="email" label="邮箱" width="150" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="备注" width="200" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="bottom">
                                <template slot="content">
                                    <p style="max-width:200px;">{{ scope.row.remark }}</p>
                                </template>
                                <div class="notice-content" v-if="scope.row.remark !== ''"> {{ scope.row.remark }}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="100" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tag type="danger" v-if="scope.row.userDataState === '0'">禁用</el-tag>
                            <el-tag type="success" v-if="scope.row.userDataState === '1'">启用</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="性别" width="60" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.sex === '0'">男</el-tag>
                            <el-tag type="info" v-if="scope.row.sex === '1'">女</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button @click="deleteUser(scope.row)" type="text" size="small">删除</el-button>
                            <el-popover style="margin-left:10px" placement="bottom" width="160" v-model="scope.row.visible">
                                <el-select v-model="modifyRole.roleId" clearable placeholder="请选择"
                                    @change="modifyAuthority(scope.row)">
                                    <el-option v-for="item in options" :key="item.id" :label="item.roleName"
                                        :value="String(item.id)">
                                    </el-option>
                                </el-select>
                                <el-button @click="openAuthority(scope.row)" type="text" size="small"
                                    slot="reference">修改权限</el-button>
                            </el-popover>
                            <el-button type="text" size="small" style="margin-left:10px"
                                @click="editUser(scope.row)">修改信息</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="userList.pageNum" :page-size="10"
                    layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

        <el-dialog :title="(userInfo.id === null ? '新增' : '编辑')" :visible.sync="dialogVisible" width="35%"
            :before-close="handleClose">
            <el-form :model="userInfo" :rules="rules" ref="userInfo" label-width="100px" class="demo-ruleForm">
                <el-form-item label="名称" prop="nickname">
                    <el-input v-model.trim="userInfo.nickname"></el-input>
                </el-form-item>
                <el-form-item label="账号" prop="accountNumber">
                    <el-input v-model.trim="userInfo.accountNumber"
                        :disabled="(userInfo.id !== null) ? true : false"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pwd" v-if="userInfo.id === null">
                    <el-input v-model="userInfo.pwd"></el-input>
                </el-form-item>
                <el-form-item label="工号" prop="jobNumber">
                    <el-input v-model.trim="userInfo.jobNumber"
                        :disabled="(userInfo.id !== null) ? true : false"></el-input>
                </el-form-item>
                <el-form-item label="在岗" prop="isOnline">
                    <el-radio-group v-model="userInfo.isOnline">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="状态" prop="userDataState">
                    <el-radio-group v-model="userInfo.userDataState">
                        <el-radio label="1">启用</el-radio>
                        <el-radio label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                    <el-radio-group v-model="userInfo.sex">
                        <el-radio label="0">男</el-radio>
                        <el-radio label="1">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="手机号" prop="phoneNumber">
                    <el-input v-model.trim="userInfo.phoneNumber"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model.trim="userInfo.email"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="userInfo.remark"></el-input>
                </el-form-item>
                <el-form-item label="头像" prop="avatar">
                    <el-upload class="upload-demo" ref="upload"
                        :headers="{ 'authorization': 'Bearer ' + this.authorization }" :action="url + 'admin/file/upload/else'"
                        :on-remove="handleRemove" :limit="1" :on-success="handleSuccess" accept=".jpg, .png">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <img :src="userInfo.avatar" v-if="userInfo.avatar" alt="头像" class="head-picture">
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="downDialog">取 消</el-button>
                <el-button v-if="userInfo.id === null" type="primary" @click="submitForm('userInfo')">确 定</el-button>
                <el-button v-else type="primary" @click="submitForm('userInfo')">编 辑</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import request from '../utils/request';
import url from '../Api/imagesUrl';
export default {
    data() {
        return {
            url,
            authorization: '',
            userInfo: {
                id: null,
                nickname: '',
                accountNumber: '',
                pwd: '',
                jobNumber: '',
                phoneNumber: null,
                email: null,
                isOnline: '',
                sex: null,
                userDataState: null,
                roleId: '',
                remark: '',
                avatar: '',
                url: ''
            },
            dialogVisible: false,
            rules: {
                nickname: [
                    { required: true, message: '请输入用户名称', trigger: 'blur' },
                ],
                accountNumber: [
                    { required: true, message: '请输账号', trigger: 'blur' },
                    { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }
                ],
                pwd: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                ],
                jobNumber: [
                    { required: true, message: '请输入工号', trigger: 'blur' },
                ],
                isOnline: [
                    { required: true, message: '请输选择是否在岗', trigger: 'blur' },
                ],
                userDataState: [
                    { required: true, message: '请输选择状态', trigger: 'blur' },
                ],
                sex: [
                    { required: true, message: '请输选择状态', trigger: 'blur' },
                ],
                phoneNumber: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { min: 11, max: 11, message: '请输入11位手机号码', trigger: 'blur' },
                    {
                        pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
                        message: '请输入正确的手机号码',
                        trigger: 'blur'
                    }
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    {
                        pattern: /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/,
                        message: '请输入正确的邮箱',
                        trigger: 'blur'
                    }
                ],
            },
            tableData: [],
            userList: {
                deptName: '',
                isPage: true,
                pageNum: 1,
                pageSize: 10,
                userName: ''
            },
            options: [],
            modifyRole: {
                roleId: '',
                userId: ''
            },
            total: 0
        }
    },
    created() {
        this.authorization = sessionStorage.getItem('authorization')
        this.getUserList()
        this.getRole()
    },
    methods: {
        // 弹窗关闭确认
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    done();
                    this.downDialog()
                })
                .catch(() => { });
        },
        //打开新增窗口
        openAdd() {
            this.dialogVisible = true
        },
        // 删除上传文件
        handleRemove() {
            this.userInfo.avatar = ''
            this.userInfo.url = ''
        },
        // 文件上传成功时
        handleSuccess(file) {
            if (file.code === '200') {
                //console.log('file', file.data);
                // let index = file.data.indexOf('file')
                // let avatar = file.data.slice(index + 4)
                // let url = file.data.slice(0, index + 4)
                let url = file.data
                this.userInfo.avatar = url
                this.userInfo.url = url
                //console.log(avatar);
                //console.log(url);
            } else {
                this.$refs.upload.clearFiles()
                this.$message.error(file.message)
            }
        },
        // 重置新增表单
        resetUsreInfo() {
            this.userInfo.id = null
            this.userInfo.nickname = ''
            this.userInfo.accountNumber = ''
            this.userInfo.pwd = ''
            this.userInfo.jobNumber = ''
            this.userInfo.phoneNumber = null
            this.userInfo.email = null
            this.userInfo.isOnline = ''
            this.userInfo.sex = null
            this.userInfo.userDataState = null
            this.userInfo.roleId = ''
            this.userInfo.remark = ''
            this.userInfo.avatar = ''
            this.userInfo.url = ''
        },
        // 重置新增弹窗
        downDialog() {
            this.dialogVisible = false
            this.resetForm('userInfo')
            this.resetUsreInfo()
        },
        // 重置表单验证
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.handleRemove()
        },
        // 表单校验
        submitForm(formName) {
            this.$refs[formName].validate(async(valid) => {
                if (valid) {
                    if (this.userInfo.id === null) {
                        await this.addUser()
                    } else {
                        await this.submitEditUser()
                    }
                    this.dialogVisible = false
                    this.downDialog()
                } else {
                    return false;
                }
            });
        },
        // 新增用户
        async addUser() {
            const res = await request({
                url: 'admin/user/add',
                method: 'POST',
                data: this.userInfo
            })
            this.$refs.upload.clearFiles()
            if (res.code === '200') {
                this.userList.deptName = ''
                this.userList.pageNum = 1
                this.getUserList()
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }
        },
        // 获取用户列表
        async getUserList() {
            const res = await request({
                url: 'admin/user/list',
                method: 'POST',
                data: this.userList
            })
            //console.log(res);
            if (res.code === '200') {
                let data = res.data && res.data.list
                data.forEach(val => {
                    val.visible = false
                })
                this.tableData = data
                this.total = res.data.total
            } else {
                this.$message.error(res.message)
            }
        },
        // 重置查询
        resetGetList() {
            this.userList.userName = ''
            this.userList.pageNum = 1
            this.getUserList()
        },
        // 删除用户
        deleteUser(val) {
            this.$confirm('确认删除？')
                .then(async () => {
                    const res = await request({
                        url: `admin/user/delete/user?accountNumber=${val.accountNumber}`,
                        method: 'GET'
                    })
                    if (res.code === '200') {
                        this.$message.success(res.message)
                        this.resetGetList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(() => { });
        },
        // 查询角色
        async getRole() {
            const res = await request({
                url: 'admin/role/list',
                method: 'POST',
                data: {
                    isPage: false,
                }
            })
            //console.log(res);
            if (res.code === '200') {
                this.options = res.data && res.data.list
            } else {
                this.$message.error(res.message)
            }
        },
        // 打开权限窗
        openAuthority(val) {
            this.modifyRole.roleId = val.roleId
            this.modifyRole.userId = ''
            this.visible = true
            //console.log(val);
            this.getRole()
        },
        //修改权限
        async modifyAuthority(val) {
            if (this.modifyRole.roleId === '') {
                return
            } else {
                this.modifyRole.userId = val.id
                let data = this.modifyRole
                val.visible = false
                const res = await request({
                    url: `admin/user/modify/user/role?roleId=${data.roleId}&&userId=${data.userId}`,
                    method: 'GET'
                })
                //console.log(res);
                if (res.code === '200') {
                    this.$message.success(res.message)
                    this.getUserList()
                    // this.getMenu()
                } else {
                    this.$message.error(res.message)
                }
            }
            //console.log(val);
        },
        //分页器
        handleCurrentChange() {
            this.getUserList()
        },
        // 模糊查询
        fuzzyQuery() {
            this.userList.pageNum = 1
            this.getUserList(0)
        },
        // 修改用户信息
        editUser(val) {
            this.dialogVisible = true
            //console.log(val);
            this.editModify(val)
        },
        // 编辑修改列表
        editModify(val) {
            this.userInfo.id = val.id
            this.userInfo.nickname = val.nickname
            this.userInfo.accountNumber = val.accountNumber
            this.userInfo.jobNumber = val.jobNumber
            this.userInfo.phoneNumber = val.phoneNumber
            this.userInfo.email = val.email
            this.userInfo.isOnline = val.isOnline
            this.userInfo.sex = val.sex
            this.userInfo.userDataState = val.userDataState
            this.userInfo.roleId = val.roleId
            this.userInfo.remark = val.remark
            // let index = val.avatar.indexOf('file')
            // let avatar = val.avatar.slice(index + 4)
            // let url = val.avatar.slice(0, index + 4)
            let url = val.avatar
            this.userInfo.avatar = url
            this.userInfo.url = url
        },
        // 提交用户修改
        async submitEditUser() {
            console.log(this.userInfo);
           
            const res = await request({
                url: 'admin/user/update',
                method: 'POST',
                data: this.userInfo
            })
            //console.log(res);
            this.$refs.upload.clearFiles()
            if (res.code === '200') {
                this.$message.success(res.message)
                this.getUserList()
            } else {
                this.$message.error(res.message)
            }
        },
        // 重新加载菜单
        // async getMenu() {
        //     const res = await request({
        //         url: 'admin/user/login/menu',
        //         method: 'GET'
        //     })
        //     if (res.code === '200') {
        //         this.menu = res.data
        //         this.$store.dispatch('updateMenu', res.data)
        //     }
        // }
    },
    filters: {
        roleFilter(val, row) {
            let roleName = ''
            val.forEach(v => {
                if (String(v.id) === row.roleId) {
                    roleName = v.roleName
                }
            })

            return roleName === '' ? '无' : roleName
        }
    }
}
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
    // display: flex;
    justify-content: space-between;


    .input-with-select {
        padding: 0;
    }
}

.search {
    line-height: 40px;
}

.head-picture {
    width: 100px;
    height: 100px;
    margin-top: 10px;
}

.block {
    text-align: right;
    background-color: #fff;
}

.global-table-box {
    margin-top: 20px;
}

.notice-content {
    height: 20px;
    overflow: hidden;
    padding: 0 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>